module.exports = __webpack_public_path__ + "img/23_35.a0dc0e4a.png";